// Utilidades para saber cuántas copias debería rendir un tóner.
//
// Cada modelo de tóner (tabla `toners`) tiene dos rendimientos:
//   - rendimiento        → copias del NEGRO (o de la única tinta)
//   - rendimiento_color  → copias de Cyan, Magenta y Yellow (los 3 rinden igual)
//                          Si está vacío (NULL), el tóner es de una sola tinta
//                          y se usa `rendimiento` para cualquier color.
//
// Las máquinas NO guardan su propio rendimiento: lo heredan del tóner.
// Así, si se corrige el rendimiento de un tóner, el cambio aplica de
// inmediato a todas las máquinas que lo usan.

// true si el color es Cyan, Magenta o Yellow (cualquier cosa que no sea negro)
export const esColorNoNegro = (color) => {
  if (!color) return false;
  return String(color).trim().toLowerCase() !== 'black';
};

// true si para este color se está usando el rendimiento de color del tóner
export const usaRendimientoColor = (toner, color) =>
  !!toner && esColorNoNegro(color) && toner.rendimiento_color != null;

// Rendimiento (sin rebajas) que corresponde a un color.
//   toner: objeto con { rendimiento, rendimiento_color }
//   color: 'Black' | 'Cyan' | 'Magenta' | 'Yellow' (vacío = negro)
export const rendimientoSegunColor = (toner, color) => {
  if (!toner) return 0;
  if (usaRendimientoColor(toner, color)) {
    return Number(toner.rendimiento_color) || 0;
  }
  return Number(toner.rendimiento) || 0;
};

// ---------------------------------------------------------------------
//  Rebaja por tipo de tóner
// ---------------------------------------------------------------------
// El rendimiento real es menor que el que indica el fabricante:
//   - Original, Integral y Katun: 20% menos.
//   - Alternativos: 40% menos.
// Para agregar un tipo nuevo, basta con sumarlo a la lista que corresponda
// (en minúsculas). Un tipo que no esté en ninguna lista no tiene rebaja.
const TIPOS_REBAJA_40 = ['sh', 'wp', 'alternativo generico', 'ggt', 'asta', 'oem', 'ppt', 'rmk'];
const TIPOS_REBAJA_20 = ['original', 'integral', 'katun'];

export const rebajaPorNombreTipo = (nombreTipo) => {
  const nombre = String(nombreTipo || '').trim().toLowerCase();
  if (TIPOS_REBAJA_40.includes(nombre)) return 0.4;
  if (TIPOS_REBAJA_20.includes(nombre)) return 0.2;
  return 0;
};

// Devuelve { rebaja: 0.4 = 40%, nombre: 'SH' } para un id de tipo de tóner
export const obtenerRebajaPorTipo = (tipoTonerId, tiposToner) => {
  if (!tipoTonerId || !Array.isArray(tiposToner)) return { rebaja: 0, nombre: '' };
  const tipo = tiposToner.find((t) => t.id === tipoTonerId);
  if (!tipo) return { rebaja: 0, nombre: '' };
  return { rebaja: rebajaPorNombreTipo(tipo.nombre), nombre: tipo.nombre };
};

// Rendimiento con la rebaja ya aplicada
export const aplicarRebajaPorTipoToner = (rendimiento, tipoTonerId, tiposToner) => {
  if (!rendimiento || !tipoTonerId) return rendimiento;
  const { rebaja } = obtenerRebajaPorTipo(tipoTonerId, tiposToner);
  return Math.round(rendimiento * (1 - rebaja));
};